import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@nexus/ui";
import { useTranslation } from "react-i18next";

export interface PersonaOpportunityExportDropdownProps {
  canExport: boolean;
  filtersActive: boolean;
  onExportAll: () => void;
  onExportFiltered: () => void;
}

export function PersonaOpportunityExportDropdown({
  canExport,
  filtersActive,
  onExportAll,
  onExportFiltered,
}: PersonaOpportunityExportDropdownProps) {
  const { t } = useTranslation();

  if (!canExport) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          iconStart="download"
          aria-label={t("personaOpportunities.workspace.export", "Export")}
        >
          {t("personaOpportunities.workspace.export", "Export")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        {filtersActive ? (
          <>
            <DropdownMenuItem className="cursor-pointer" onSelect={onExportFiltered}>
              {t("personaOpportunities.export.exportFiltered", "Export filtered")}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        ) : null}
        <DropdownMenuItem className="cursor-pointer" onSelect={onExportAll}>
          {t("personaOpportunities.export.exportAll", "Export all")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
